import React from 'react';
import {Table} from "react-bootstrap";
import numberFormat from "../../../helpers/numberFormat";
import _ from "lodash";
import moment from "moment";


const PaymentsTable = ({editbleArray,setEditableArray,}) => {

  const addPaymentToMainTable = (index) =>{
    const array = structuredClone(editbleArray.tableData)
    const arrPayments = structuredClone(editbleArray.payments)
    const itemPayment = arrPayments[index]
    const neededIndex = _.findIndex(
      array.tableData,
      item => {
        return moment(item.issueDate, 'DD.MM.YYYY', true)
          .isAfter(moment(itemPayment.issueDate, 'DD.MM.YYYY', true))
      }
    );
    if (neededIndex === -1) {
      array.tableData.push(itemPayment);
    } else {
      array.tableData.splice(neededIndex, 0, itemPayment);
    }
    arrPayments.splice(index, 1)
    setEditableArray({...editbleArray,tableData:array,payments: arrPayments})
  }

  return (
    <div>
      <h3>Оплаты</h3>
      <Table striped bordered hover>
        <thead>
        <tr>
          <td>№</td>
          <td>Операция</td>
          <td>Описание</td>
          <td>Комментарий</td>
          <td>Итого</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        {editbleArray.payments.map((row, index)=>{
          return <tr key={index}>
            <td>{index + 1}.</td>
            <td>{row.operation}</td>
            <td>{row.route}</td>
            <td>{row.description}</td>
            <td>{numberFormat(row.total)}</td>
            <td className={'text-center p-0'} style={{fontSize: 22}}>
              <i className="fa fa-plus-square text-primary pointer"
                 onClick={() => {
                   addPaymentToMainTable(index)
                 }}/>
            </td>
          </tr>
        })}
        </tbody>
      </Table>

    </div>
  );
};

export default PaymentsTable;
